module.exports = __webpack_public_path__ + "static/Realestate-b12c4e8f4dc00386337cc37db1f30f95.svg";